FamilycardsImageLibrary.controller('editorDesignsController', [ '$scope', function( $scope ) {
    
	$scope.addDesignForm = { new_client: "0" };

}]);